export const formatWebsiteUrl = (website) => {
    return website.includes('://') ? website : `https://${website}`;
};
export const formatDateForTable = (dateString) => {
    if (!dateString)
        return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};
export const formatDate = (dateString) => {
    if (!dateString)
        return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
export const formatPhoneForTable = (clinic) => {
    let phone = clinic.phone;
    if (typeof phone === 'string' && phone.startsWith('{')) {
        try {
            phone = JSON.parse(phone);
        }
        catch (e) {
            // Ignore parsing error, continue with phone as-is
        }
    }
    if (typeof phone === 'object' && phone) {
        const phoneObj = phone;
        if (phoneObj.formatted_number) {
            return phoneObj.formatted_number;
        }
        if (phoneObj.area_code && phoneObj.exchange && phoneObj.line) {
            return `${phoneObj.area_code}-${phoneObj.exchange}-${phoneObj.line}`;
        }
        const number = phoneObj.number || '';
        const cleaned = number.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        return number || 'N/A';
    }
    if (typeof phone === 'string') {
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (uuidPattern.test(phone)) {
            return 'N/A';
        }
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        return phone;
    }
    return 'N/A';
};
export const formatPhone = (phone) => {
    if (!phone)
        return 'N/A';
    if (typeof phone === 'string')
        return phone;
    const number = phone.number || '';
    const cleaned = number.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return number || 'N/A';
};
export const formatAddress = (address) => {
    if (!address)
        return 'N/A';
    if (typeof address === 'string')
        return address;
    const parts = [];
    if (address.street1 || address.street_1)
        parts.push(address.street1 || address.street_1);
    if (address.street2 || address.street_2)
        parts.push(address.street2 || address.street_2);
    if (address.city &&
        address.state &&
        (address.postalCode || address.postal_code)) {
        parts.push(`${address.city}, ${address.state} ${address.postalCode || address.postal_code}`);
    }
    return parts.length > 0 ? parts.join('\n') : 'N/A';
};
export const formatCurrencyForTable = (amount) => {
    if (!amount && amount !== 0)
        return 'N/A';
    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(numericAmount);
};
export const formatStatusLabel = (status) => {
    return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};
export const getStatusBadgeColors = (status) => {
    const colorMap = {
        pending: { background: '#FFFFFF', text: '#2A2E2E' },
        approved: { background: '#EBFEF6', text: '#00654F' },
        rejected: { background: '#FFF0F3', text: '#AC0824' },
        on_hold: { background: '#FFF4CC', text: '#B45309' },
    };
    const normalizedStatus = status.toLowerCase().replace(/\s+/g, '_');
    return (colorMap[normalizedStatus] || {
        background: undefined,
        text: undefined,
    });
};
export const getBooleanStatusBadgeColors = (isActive) => (isActive
    ? { background: '#EBFEF6', text: '#00654F' }
    : { background: '#FFF0F3', text: '#AC0824' });
const MANAGEMENT_STATUS_COLOR_MAP = {
    active: { background: '#EBFEF6', text: '#00654F' },
    approved: { background: '#EBFEF6', text: '#00654F' },
    delivered: { background: '#D4EDDA', text: '#155724' },
    submitted: { background: '#D1ECF1', text: '#0C5460' },
    shipped: { background: '#FFF3CD', text: '#856404' },
    pending: { background: '#FFFFFF', text: '#2A2E2E' },
    inactive: { background: '#FFF0F3', text: '#AC0824' },
    rejected: { background: '#FFF0F3', text: '#AC0824' },
    cancelled: { background: '#F8D7DA', text: '#721C24' },
    canceled: { background: '#F8D7DA', text: '#721C24' },
    on_hold: { background: '#FFF4CC', text: '#B45309' },
    expired: { background: '#FFF3CD', text: '#856404' },
    used_up: { background: '#F3F4F6', text: '#374151' },
};
export const getManagementStatusBadgeColors = (status) => {
    const normalizedStatus = status.toLowerCase().trim().replace(/\s+/g, '_');
    return (MANAGEMENT_STATUS_COLOR_MAP[normalizedStatus] || {
        background: '#FFFFFF',
        text: '#2A2E2E',
    });
};
